import { createSelector } from 'reselect'

const hostDnsSelector = (store) => store.hostDns

export const selectAvApiHost = createSelector([hostDnsSelector], (hostDns) => hostDns.avApi)
export const selectAuthApiHost = createSelector([hostDnsSelector], (hostDns) => hostDns.authApi)
export const selectMembershipApiHost = createSelector([hostDnsSelector], (hostDns) => hostDns.membershipApi)
export const selectEventStoreApiHost = createSelector([hostDnsSelector], (hostDns) => hostDns.eventStoreApi)
